import React from 'react'
import { FormSimpleSelectBool } from './form-select-bool'
import { FormSimpleText } from './form-text'
import { FormSimpleNumber } from './form-number'
import { FormSimpleFloat } from './form-float'
import { FormSimpleVector2 } from './form-vector2'
import { FormSimpleVector3 } from './form-vector3'
import { FormSimpleVector4 } from './form-vector4'
import { FormSimpleColorRgba } from './form-color-rgba'

export const FormSimplePersistenceDefaultValue = ({ name, label, required, hidden, readonly, type }) => {
  return (
    <React.Fragment>
      {(() => {
        switch (type) {
          case 'Bool':
            return <FormSimpleSelectBool name={name} label={label} required={required} hidden={hidden} readonly={readonly} />
          case 'String':
            return <FormSimpleText name={name} label={label} required={required} hidden={hidden} readonly={readonly} />
          case 'Color':
            return <FormSimpleColorRgba name={name} label={label} required={required} hidden={hidden} readonly={readonly} />
          case 'Int':
            return <FormSimpleNumber name={name} label={label} required={required} hidden={hidden} readonly={readonly} />
          case 'Long':
            return <FormSimpleNumber name={name} label={label} required={required} hidden={hidden} readonly={readonly} />
          case 'Float':
            return <FormSimpleFloat name={name} label={label} required={required} hidden={hidden} readonly={readonly} />
          case 'Vector2':
            return <FormSimpleVector2 name={name} label={label} required={required} hidden={hidden} readonly={readonly} />
          case 'Vector3':
            return <FormSimpleVector3 name={name} label={label} required={required} hidden={hidden} readonly={readonly} />
          case 'Vector4':
          case 'Quaternion':
            return <FormSimpleVector4 name={name} label={label} required={required} hidden={hidden} readonly={readonly} />
          default:
            return <React.Fragment />
        }
      })()}
    </React.Fragment>
  )
}
